import { useState } from "react";
// import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useContent } from "../../hooks/useContent";
import React, { useEffect } from "react";

const AuctionCard = ({ item = {}, special = false }) => {
  // ----------- hooks ------------
  const { t, i18n } = useTranslation();
  const { projects, fetchProjects } = useContent();

  // const [data, setData] = useState([
  //   <p className="py-3 text-lg font-medium text-black">
  //     {special ? item.special_content : item.content}
  //   </p>,
  //   <div className="mt-5 rounded-xl overflow-hidden">
  //     <img src={item.special_image} alt="img" />
  //   </div>,
  // ]);
  useEffect(() => {
    fetchProjects();
  }, [i18n.language]);
  return (
    <div className={"auction relative py-14"}>
      <Fade bottom>
        <div
        
          style={{
            cursor: "pointer",
            backgroundImage: `url("${item.special_image}")`,
          }}
          className="auction-section relative border border-slate-200 "
        >
          <div className={` action-card rounded-xl bg-white p-5 break-words   ${i18n.language === 'ar' ? 'rtl': 'ltr'}`} style={{direction: 'auto'}}>
            <div className="h-72 break-words line-clamp-9 ">
              <h1 className="font-semibold text-2xl text-purple  line-clamp-9   ">
                {item.title}
              </h1>
              <p className="break-words line-clamp-9 pt-4">

              {special ?item.content  : item.special_content}
              </p>
            </div>
            <div className="flex flex-row justify-between items-center pt-5">
              <Link to={`/projects/${item.id}`}>
                <p className="text-gray font-medium">{t("More")}</p>
              </Link>
              {/* <div className="flex flex-row gap-3">
                <div
                  onClick={() => {
                    const arr = [...data];
                    const lastElement = arr.shift();
                    arr.push(lastElement);
                    setData(arr);
                  }}
                  className="w-12 h-12 flex items-center cursor-pointer hover:shadow-xl justify-center rounded-full  text-black hover:text-white hover:bg-purple"
                >
                  {i18n.language === "ar" ? (
                    <BsChevronRight className="text-2xl cursor-pointer" />
                  ) : (
                    <BsChevronLeft className="text-2xl cursor-pointer" />
                  )}
                </div>
                <div
                  onClick={() => {
                    const arr = [...data];
                    const lastElement = arr.pop();
                    arr.unshift(lastElement);
                    setData(arr);
                  }}
                  className="w-12 h-12 flex items-center cursor-pointer hover:shadow-xl justify-center rounded-full text-black hover:text-white hover:bg-purple"
                >
                  {i18n.language === "ar" ? (
                    <BsChevronLeft className="text-2xl cursor-pointer" />
                  ) : (
                    <BsChevronRight className="text-2xl cursor-pointer" />
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default AuctionCard;
